export default "__VITE_ASSET__Lj4ayi$P__"